









































import { Component } from 'vue-property-decorator';
import ActivitySessionsAttendees from '@activities/mixins/activity-sessions-attendees';
import { mixins } from 'vue-class-component';
import PageTitle from '@shared/layouts/components/page-title/page-title.vue';
import EnrollFamilyMemberModal from '@activities/components/modals/enroll-family-member-modal/enroll-family-member-modal.vue';

@Component({
  name: 'bpc-profile-activity-sessions',
  components: {
    'bpc-page-title': PageTitle,
    'bpc-enroll-family-member-modal': EnrollFamilyMemberModal,
  },
})
export default class ProfileActivitySession extends mixins(ActivitySessionsAttendees) {
  declare $refs: ActivitySessionsAttendees['$refs'] & {
    enrollFamilyMemberModal: InstanceType<typeof EnrollFamilyMemberModal> & {
      onOpenModal(): void;
      onCloseModal(): void;
    };
  };

  // PROPS
  // DATA
  attendeeModalKey = 0;
  /* Lifecycle hooks */
  // created() {}
  mounted() {
    this.userIsLoggedIn = this.$authService.loggedIn;
  }
  // updated() {}
  // destroyed() {}

  // METHODS
  public onEnrollFamilyMember() {
    this.$refs.enrollFamilyMemberModal.onOpenModal();
  }

  refreshContacts() {
    this.attendeeModalKey++;
  }
}
